import injectSheet from 'lib/sheet';
import sheet from './sheet';
import DataTable from 'lib/dataTable/DataTable';

export default injectSheet(sheet)(DataTable);
